import { useState,useEffect } from 'react'
import { ChevronsUp } from 'react-feather'
import util from '@utils/utils'

export const ScrolltoTopBtn = () => {
    const [upBtnVisible,setUpBtnVisible] = useState(false)
    useEffect(()=>{
        window.addEventListener("scroll",e=>{
            util?.throttle(setUpBtnStatus(),1000)
        })
    },[])
    const setUpBtnStatus = () => {
        let scrollTop = document.documentElement.scrollTop
        // console.log(scrollTop)
        if(scrollTop > 500){
            setUpBtnVisible(true)
        }else{
            setUpBtnVisible(false)
        }
    }
    
    return (
        <>
            {upBtnVisible && <div id="scroll-to-top-btn" className="z-30">
                <button className="bg-base-100 group btn hover:btn-primary hover:text-white shadow-lg h-4" 
                    onClick={()=>window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    })}
                >
                    <ChevronsUp size="1.5rem"/>
                    <span className='group-hover:block hidden'>回到顶部</span>
                </button>
            </div>}
        </>
    )
}